// extracted by mini-css-extract-plugin
export default {"dragging":"AoaQj"};